import { Route } from "./core/route/Route";
import { Form } from "./data-entry/Form";
import { Home } from "./pages/Home";
import { Settings } from "./pages/admin/Settings";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Profile } from "./pages/profile/Profile";
import { VerifyEmail } from "./pages/register/VerifyEmail";
import { Entities } from "./pages/entity/Entities";
import { PrintTest } from "./pages/report/PrintTest";
import { Forms } from "./pages/admin/Forms";
import { Ref } from "./pages/admin/Ref";
import { Resources } from "./pages/admin/Resources";
import { GenerateWorkflowPdf, GenerateWorkflowZip } from "./GenerateWorkflowPdf";
import { Reports } from "./pages/admin/Reports";
import { AcceptInvitation } from "./pages/register/AcceptInvitation";
import { BreadcrumbRegion } from "./core/ui/Breadcrumb";
import { Workflows } from "./pages/admin/Workflows";
import { Scripts } from "./pages/admin/Scripts";
import { EventDetailsPdf } from "./EventDetailsPdf";
import { Billing } from "./pages/profile/Billing";
import { TechsyncHome, TechsyncJobCard } from "./techsync/TechsyncHome";

export function Routes() {

	if (window.location.host === "techsync.app" && !window.location.pathname.startsWith("/techsync/")) {
		window.location.href = "/techsync/";
		return null;
	}


	return (
		<>
			<Route match='/dashboard/' exact={false} render={() => <Dashboard />} />

			<BreadcrumbRegion url="/dashboard/" title="Dashboard">
				
				<BreadcrumbRegion url="/profile/" title="My Account">
					<Route match='/profile/' exact={true} render={() => <Profile />} />
				</BreadcrumbRegion>

				<BreadcrumbRegion url="/billing/" title="Billing">
					<Route match='/billing/' exact={true} render={() => <Billing />} />
				</BreadcrumbRegion>

				<Route match='/form/:id/' exact={true} render={(props) => <Form {...props} />} />

				<BreadcrumbRegion url="/admin/settings/" title="Settings">
					<Route match='/admin/settings/' exact={true} render={() => <Settings />} />

					<BreadcrumbRegion title="Forms">
						<Route match='/admin/forms/' exact={true} render={() => <Forms />} />
					</BreadcrumbRegion>

					<BreadcrumbRegion title="Reference Tables">
						<Route match='/admin/ref/' exact={true} render={() => <Ref />} />
					</BreadcrumbRegion>

					<BreadcrumbRegion title="Resources">
						<Route match='/admin/resources/' exact={true} render={() => <Resources />} />
					</BreadcrumbRegion>
					
					<BreadcrumbRegion title="Reports">
						<Route match='/admin/reports/' exact={true} render={() => <Reports />} />
					</BreadcrumbRegion>

					<BreadcrumbRegion title="Workflows">
						<Route match='/admin/workflows/' exact={true} render={() => <Workflows />} />
					</BreadcrumbRegion>

					<BreadcrumbRegion title="Scripts">
						<Route match='/admin/scripts/' exact={true} render={() => <Scripts />} />
					</BreadcrumbRegion>

				</BreadcrumbRegion>

				<BreadcrumbRegion title="Entities">
					<Route match='/entity/' exact={true} render={(props) => <Entities {...props} />} />
				</BreadcrumbRegion>

			</BreadcrumbRegion>


			<Route match='/verify-email' render={() => <VerifyEmail />} />
			<Route match='/accept-invitation' render={() => <AcceptInvitation />} />



			<Route match='/report/' exact={true} render={(props) => <PrintTest {...props} />} />


			<Route match='/pdf/:defID/:formID/' exact={false} render={(props) => <GenerateWorkflowPdf {...props} />} />
			<Route match='/pdf-download/:awfID/' exact={false} render={(props) => <GenerateWorkflowZip {...props} />} />
			<Route match='/event/:eventID/' exact={false} render={(props) => <EventDetailsPdf {...props} />} />

			<Route match='/' exact={true} render={() => <Home />} />

			<Route match='/techsync/' exact={true} render={() => <TechsyncHome />} />
			<Route match='/techsync/:jobID/' exact={true} render={(props) => <TechsyncJobCard {...props} />} />


		</>
	);
}



